import { ILinkFields, ILink } from '../../../types/@types/generated/contentful';
import { isLandingPage } from './typeGuards';

const getInternalHref = ({ reference }: { reference: ILinkFields['internalRef'] }) => {
  if (!reference) {
    return;
  }
  if (isLandingPage(reference)) {
    if (reference.fields.slug === 'give-a-gift') {
      return '/gift';
    }

    return `/${reference.fields.slug}`; // TODO this has to be improved, depending on tags the sub directory can change
  }
  return `#${reference.sys.id}`;
};

const getLinkHref = (link?: ILink) => {
  if (!link) return undefined;
  return link?.fields.externalUrl || getInternalHref({ reference: link?.fields.internalRef });
};

export default getLinkHref;
